import { ready } from "@/lib/ready";
import { on } from "@/lib/dom/on";
import { hideElement } from "@/lib/dom/hideElement";
import { removeClass } from "@/lib/dom/removeClass";
import { addStyle } from "@/lib/dom/addStyle";
import { addClass } from "@/lib/dom/addClass";

const InitMobileButton = () => {
  const mobileBtn = document.querySelectorAll('.mobile-catgory-button');
  if (mobileBtn.length == 2) {
    on(mobileBtn[0], 'click', function () {
      // showElement('.mobile-catgory-list')
      // s();
    });

    on(mobileBtn[1], 'click', function () {
      addStyle('.mobile-catgory-Sort', 'display', 'block')
    });

    on('.mobile-catgory-Sort span', 'click', () => {
      hideElement('.mobile-catgory-Sort')
    })
  }
}

const InitMobileNarrow = () => {
  const sidebar = document.querySelector('.container-sidebar')!;

  const mobileBtn = document.querySelectorAll('.mobile-catgory-button');
  if (mobileBtn.length == 2) {
    on(mobileBtn[0], 'click', () => {
      addClass(sidebar, 'is-open');
    })
  }

  const closeDrawer = (el: HTMLElement) => {
    removeClass(sidebar, 'is-open');
  }

  const mobileCloseBtn = document.querySelector('.mobile-close-btn');
  if (mobileCloseBtn) {
    on(mobileCloseBtn, 'click', () => {
      removeClass(sidebar, 'is-open');
    })
  }
  on(sidebar, 'click', (e: MouseEvent) => {
    const target = e.target as HTMLElement
    if (target!.closest(".mobile-close-btn") || target!.classList.contains("container-sidebar")) {
      e.preventDefault();
      closeDrawer(target as HTMLElement)
    }
  })
}

ready(() => {
  InitMobileButton();
  InitMobileNarrow();
})